import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/components/Home.vue'
import ClientDetail from '@/views/ClientDetail.vue'
import ClientWorkflowSettings from '@/components/ClientWorkflowSettings.vue'
import WorkflowDesigner from '@/components/WorkflowDesigner.vue'
import WorkflowFromDocument from '@/views/WorkflowFromDocPage.vue'
import Login from '@/views/Login.vue'
import ForgotPassword from '@/views/ForgotPassword.vue'
import ResetPassword from '@/views/ResetPassword.vue'

import Logout from '@/views/Logout.vue'
import ProjectDocuments from '@/components/ProjectDocuments.vue'
import ComprehensiveAnalysisDashboard from '@/components/comprehensive/ComprehensiveAnalysisDashboard.vue'
import ComplianceDashboard from '@/views/ComplianceDashboard.vue'
import ProjectBatchTools from '@/views/ProjectBatchTools.vue'
import EntityRecordView from '@/views/EntityRecordView.vue'
import PatientChartView from '@/views/PatientChartView.vue'
import Settings from '@/components/Settings.vue'
import SettingsSecurity from '@/views/SettingsSecurity.vue'
import AgentProfileSettings from '@/views/AgentProfileSettings.vue'
import UserProfile from '@/components/UserProfile.vue'
import AccountPlatformHub from '@/views/AccountPlatformHub.vue'
import AccountMarketingHub from '@/views/AccountMarketingHub.vue'
import AnalysisRequestQueue from '@/views/RequestsView.vue'
import WorkflowRunner from '@/components/WorkflowRunner.vue'
import ComprehensiveAnalysis from '@/components/comprehensive/ComprehensiveAnalysis.vue'
import ActionsManager from '@/components/ActionsManager.vue'
import AutomatedChecksManager from '@/components/AutomatedChecksManager.vue'
import ComprehensiveCheckDefinitionEditor from '@/views/ComprehensiveCheckDefinitionEditor.vue'
import ResearchCampaignWizard from '@/views/ResearchCampaignWizard.vue'
import LiveComplianceReport from '@/views/LiveComplianceReport.vue'
import ComplianceResponsivenessReport from '@/views/ComplianceResponsivenessReport.vue'
import ActiveLocationsReport from '@/views/ActiveLocationsReport.vue'
import FranchiseDataHub from '@/views/FranchiseDataHub.vue'
import CoiIntegrations from '@/views/CoiIntegrations.vue'
import GrowthContacts from '@/views/GrowthContacts.vue'
import ScavRosterContacts from '@/views/ScavRosterContacts.vue'
import ImportOnboarding from '@/views/ImportOnboarding.vue'
import BatchProcessing from '@/views/BatchProcessing.vue'
import RAGAnalyticsDemo from '@/views/RAGAnalyticsDemo.vue'
import RAGAdminDashboard from '@/views/RAGAdminDashboard.vue'
import StatusChangesReport from '@/components/StatusChangeManager.vue'
import PromptEnhancement from '@/components/PromptEnhancementManager.vue'
import DSPyTestPage from '@/views/DSPyTestPage.vue'
import ProjectSettings from '@/views/ProjectSettings.vue'
// import ProjectHub from '@/views/ProjectHub.vue' // Removed - using new ComplianceDashboard instead
import Project68Processing from '@/views/Project68Processing.vue'
import RAGAnalysis from '@/views/RAGAnalysis.vue'
import UserManagement from '@/views/UserManagement.vue'
import OrganizationSettings from '@/views/OrganizationSettings.vue'
import OrgEmailBranding from '@/views/OrgEmailBranding.vue'
import OrganizationSetupWizard from '@/views/OrganizationSetupWizard.vue'
import ComplianceOnboardingWizard from '@/views/ComplianceOnboardingWizard.vue'
import ClientManagementDashboard from '@/views/ClientManagementDashboard.vue'
import PortfolioHub from '@/views/PortfolioHub.vue'
import PortfolioClientsList from '@/views/PortfolioClientsList.vue'
import ProjectsList from '@/components/ProjectsList.vue'
import BillingSettings from '@/views/BillingSettings.vue'
import ConnectOnboarding from '@/views/ConnectOnboarding.vue'
// Secure Upload Multi-Step Views
import SecureUploadLanding from '@/views/SecureUploadLanding.vue'
import SecureUploadAnalysis from '@/views/SecureUploadAnalysis.vue'
import SecureUploadResults from '@/views/SecureUploadResults.vue'
import SecureUploadFeedback from '@/views/SecureUploadFeedback.vue'
import SecureUploadComplete from '@/views/SecureUploadComplete.vue'
import CoiImport from '@/views/CoiImport.vue'
import auth from '@/services/auth'
import {
  isSpeakerAllowedPath,
  isComplianceOpsAllowedPath,
  storeAccessDeniedNotice,
} from '@/router/routeAccess'
import {
  isLearningPortalOrg,
  isVmaeAssociationHost,
  learningHomeLocation,
} from '@/utils/associationPortal'
import RAGCarrierFocusedDemo from '@/views/RAGCarrierFocusedDemo.vue'
import CarrierAnalytics from '@/views/CarrierAnalytics.vue'
import ABTestingDashboard from '@/views/ABTestingDashboard.vue'
import ComplianceHealthDashboard from '@/views/ComplianceHealthDashboard.vue'
import EmailDeliveryHealth from '@/views/EmailDeliveryHealth.vue'
import ComplianceConsult from '@/views/ComplianceConsult.vue'
import WealthReviewDashboard from '@/views/WealthReviewDashboard.vue'
import QuarterlyReviewPacket from '@/views/QuarterlyReviewPacket.vue'
import IPSEditor from '@/views/IPSEditor.vue'
import EventImpactDashboard from '@/views/EventImpactDashboard.vue'
import WealthAdvisorConsult from '@/views/WealthAdvisorConsult.vue'
import RequirementLab from '@/views/RequirementLab.vue'
import DatabaseConnections from '@/views/DatabaseConnections.vue'
import DuplicateDetection from '@/views/DuplicateDetection.vue'
import APIIntegrations from '@/views/APIIntegrations.vue'
import DataSourceMonitor from '@/views/DataSourceMonitor.vue'
import SourceCatalog from '@/views/SourceCatalog.vue'
import RegulatoryIntelligence from '@/views/RegulatoryIntelligence.vue'
import SavedViews from '@/views/SavedViews.vue'
import RegulatoryAlerts from '@/views/RegulatoryAlerts.vue'
import DataSubscriptions from '@/views/DataSubscriptions.vue'
import FeedbackDashboard from '@/views/FeedbackDashboard.vue'
// LMS imports
import LearningCatalog from '@/views/LearningCatalog.vue'
import MyLibrary from '@/views/MyLibrary.vue'
import CourseDetail from '@/views/CourseDetail.vue'
import CourseVideoPlayer from '@/views/CourseVideoPlayer.vue'
import MyLearning from '@/views/MyLearning.vue'
import LearningPaths from '@/views/LearningPaths.vue'
import LMSAdmin from '@/views/LMSAdmin.vue'
import CourseCertificate from '@/views/CourseCertificate.vue'
// SCAV Member Verification
import RegisterSCAV from '@/views/RegisterSCAV.vue'
import RegisterGuest from '@/views/RegisterGuest.vue'
import VerifyMember from '@/views/VerifyMember.vue'
// Vet Media Group public marketing landing
import VetMediaPublic from '@/views/VetMediaPublic.vue'
// VMAE association-branded member portal landing
import AssociationPortalLanding from '@/views/AssociationPortalLanding.vue'
// Vet license verification (Phase D — verified clinician flow)
import VerifyVetLicense from '@/views/VerifyVetLicense.vue'
// Quote & Proposal Generator
import QuoteBuilder from '@/views/QuoteBuilder.vue'
import QuoteEditor from '@/views/QuoteEditor.vue'
import QuotesList from '@/views/QuotesList.vue'
// Legal & Compliance Pages
import Subprocessors from '@/views/Subprocessors.vue'
import BAASigningPage from '@/views/BAASigningPage.vue'
import FieldReadiness from '@/views/FieldReadiness.vue'
import BuildHub from '@/views/BuildHub.vue'
// Invoicing
import InvoiceList from '@/views/invoicing/InvoiceList.vue'
import InvoiceEditor from '@/views/invoicing/InvoiceEditor.vue'
import InvoiceDetail from '@/views/invoicing/InvoiceDetail.vue'
import BusinessExpenses from '@/views/invoicing/BusinessExpenses.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: false }
  },
  // Legal & Compliance Pages
  {
    path: '/subprocessors',
    name: 'Subprocessors',
    component: Subprocessors,
    meta: { requiresAuth: false }
  },
  // Vet Media Group public marketing landing — Turnstile-gated demo
  {
    path: '/vetmedia',
    name: 'VetMediaPublic',
    component: VetMediaPublic,
    meta: { requiresAuth: false }
  },
  {
    path: '/portal',
    name: 'AssociationPortal',
    component: AssociationPortalLanding,
    meta: { requiresAuth: false }
  },
  {
    path: '/welcome-vet',
    name: 'VetMediaPublicAlt',
    component: VetMediaPublic,
    meta: { requiresAuth: false }
  },
  {
    path: '/verify-license',
    name: 'VerifyVetLicense',
    component: VerifyVetLicense,
    meta: { requiresAuth: true }
  },
  // SCAV Member Registration & Verification
  {
    path: '/register-scav',
    name: 'RegisterSCAV',
    component: RegisterSCAV,
    meta: { requiresAuth: false }
  },
  {
    path: '/register',
    name: 'RegisterGuest',
    component: RegisterGuest,
    meta: { requiresAuth: false }
  },
  {
    path: '/verify-member/:token',
    name: 'VerifyMember',
    component: VerifyMember,
    meta: { requiresAuth: false }
  },
  {
    path: '/field/readiness/:lotId/:tradeType',
    name: 'FieldReadiness',
    component: FieldReadiness,
    meta: { requiresAuth: false }
  },
  {
    path: '/site-media/timeline',
    name: 'SiteMediaTimeline',
    component: () => import('@/views/SiteMediaTimelineView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/data-suggestions',
    redirect: '/compliance-health',
  },
  {
    path: '/carrier-intelligence',
    name: 'CarrierIntelligence',
    component: () => import('@/views/CarrierIntelligence.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/ab-testing',
    name: 'ABTestingDashboard',
    component: ABTestingDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/database-connections',
    name: 'DatabaseConnections',
    component: DatabaseConnections,
    meta: { requiresAuth: true },
  },
  {
    path: '/quote-builder',
    name: 'QuoteBuilder',
    component: QuoteBuilder,
    meta: { requiresAuth: true }
  },
  {
    path: '/quotes',
    name: 'QuotesList',
    component: QuotesList,
    meta: { requiresAuth: true }
  },
  {
    path: '/quote-editor/:id',
    name: 'QuoteEditor',
    component: QuoteEditor,
    meta: { requiresAuth: true }
  },
  {
    path: '/duplicate-detection',
    name: 'DuplicateDetection',
    component: DuplicateDetection,
    meta: { requiresAuth: true },
  },
  {
    path: '/api-integrations',
    name: 'APIIntegrations',
    component: APIIntegrations,
    meta: { requiresAuth: true },
  },
  {
    path: '/regulatory-intelligence',
    name: 'RegulatoryIntelligence',
    component: RegulatoryIntelligence,
    meta: { requiresAuth: true },
  },
  {
    path: '/regulatory/saved-views',
    name: 'SavedViews',
    component: SavedViews,
    meta: { requiresAuth: true },
  },
  {
    path: '/regulatory/alerts',
    name: 'RegulatoryAlerts',
    component: RegulatoryAlerts,
    meta: { requiresAuth: true },
  },
  {
    path: '/policy-monitor',
    name: 'DataSourceMonitor',
    component: DataSourceMonitor,
    meta: { requiresAuth: true },
  },
  {
    path: '/source-catalog',
    name: 'SourceCatalog',
    component: SourceCatalog,
    meta: { requiresAuth: true },
  },
  {
    path: '/data-subscriptions',
    name: 'DataSubscriptions',
    component: DataSubscriptions,
    meta: { requiresAuth: true },
  },
  {
    path: '/intake-queue',
    name: 'IntakeQueue',
    component: () => import('@/components/intake/IntakeQueue.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/clients',
    name: 'Clients',
    component: PortfolioHub,
    meta: { requiresAuth: true },
  },
  {
    path: '/clients/all',
    name: 'PortfolioClientsAll',
    component: PortfolioClientsList,
    meta: { requiresAuth: true },
  },
  {
    path: '/clients/:id',
    name: 'ClientDetail',
    component: ClientDetail,
    meta: { requiresAuth: true },
  },
  {
    path: '/clients/:clientId/workflow-settings',
    name: 'ClientWorkflowSettings',
    component: ClientWorkflowSettings,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:projectId/settings',
    name: 'ProjectSettings',
    component: ProjectSettings,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { requiresAuth: false }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { requiresAuth: false }
  },
  {
    path: '/unsubscribe/:token',
    name: 'EmailUnsubscribe',
    component: () => import('@/views/EmailUnsubscribe.vue'),
    meta: { requiresAuth: false },
  },
  // Registration route temporarily disabled for security
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: Register
  // },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/projects',
    name: 'Projects',
    component: ProjectsList,
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:id',
    name: 'ComplianceDashboard',
    component: ComplianceDashboard,
    props: route => ({ projectId: route.params.id }),
    meta: { requiresAuth: true }
  },
  {
    path: '/projects/:projectId/compliance-health/email-delivery',
    name: 'ProjectEmailDelivery',
    component: EmailDeliveryHealth,
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:projectId/batch-tools',
    name: 'ProjectBatchTools',
    component: ProjectBatchTools,
    props: route => ({ projectId: route.params.projectId }),
    meta: { requiresAuth: true }
  },
  {
    path: '/projects/:projectId/match-hygiene',
    name: 'ProjectMatchHygiene',
    component: () => import('@/views/MatchHygieneView.vue'),
    props: route => ({ projectId: route.params.projectId }),
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:projectId/patients/:subjectId/chart',
    name: 'PatientChart',
    redirect: (to) => ({
      name: 'LearningPatientChart',
      params: { subjectId: to.params.subjectId },
    }),
  },
  {
    path: '/projects/:projectId/entities/:subjectId',
    name: 'EntityRecord',
    component: EntityRecordView,
    props: route => ({
      projectId: route.params.projectId,
      subjectId: route.params.subjectId,
    }),
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:id/documents',
    name: 'ProjectDocuments',
    component: ProjectDocuments,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:projectId/compliance',
    name: 'ComplianceIntelligence',
    component: ComprehensiveAnalysisDashboard,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:projectId/rag-analysis',
    name: 'RAGAnalysis',
    component: RAGAnalysis,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:projectId/lab',
    name: 'RequirementLab',
    component: RequirementLab,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/project68/processing',
    name: 'Project68Processing',
    component: Project68Processing,
    meta: { requiresAuth: true }
  },
  {
    path: '/workflows',
    name: 'WorkflowDesigner',
    component: WorkflowDesigner,
    meta: { requiresAuth: true },
  },
  {
    path: '/workflow-designer',
    name: 'WorkflowDesignerDirect',
    component: WorkflowDesigner,
    meta: { requiresAuth: true },
  },
  {
    path: '/workflow-from-document',
    name: 'WorkflowFromDocument',
    component: WorkflowFromDocument,
    meta: { requiresAuth: true },
  },
  {
    path: '/requests',
    name: 'AnalysisRequestQueue',
    component: AnalysisRequestQueue,
    meta: { requiresAuth: true },
  },
  {
    path: '/workflows/:id/execute',
    name: 'WorkflowExecution',
    component: WorkflowRunner,
    meta: { requiresAuth: true },
  },
  {
    path: '/analysis/comprehensive',
    name: 'ComprehensiveAnalysis',
    component: ComprehensiveAnalysis,
    meta: { requiresAuth: true },
  },
  {
    path: '/actions',
    name: 'ActionsManager',
    component: ActionsManager,
    meta: { requiresAuth: true },
  },
  {
    path: '/automated-checks',
    name: 'AutomatedChecksManager',
    component: AutomatedChecksManager,
    meta: { requiresAuth: true },
  },
  {
    path: '/check-definition-editor',
    name: 'ComprehensiveCheckDefinitionEditor',
    component: ComprehensiveCheckDefinitionEditor,
    meta: { requiresAuth: true },
  },
  {
    path: '/campaigns',
    name: 'ResearchCampaigns',
    component: ResearchCampaignWizard,
    meta: { requiresAuth: true },
  },
  {
    path: '/campaigns/:id',
    name: 'ResearchCampaignDetail',
    component: ResearchCampaignWizard,
    meta: { requiresAuth: true },
  },
  {
    path: '/compliance-report',
    name: 'LiveComplianceReport',
    component: LiveComplianceReport,
    meta: { requiresAuth: true },
  },
  {
    path: '/compliance-responsiveness',
    name: 'ComplianceResponsivenessReport',
    component: ComplianceResponsivenessReport,
    meta: { requiresAuth: true },
  },
  {
    path: '/active-locations-report',
    name: 'ActiveLocationsReport',
    component: ActiveLocationsReport,
    meta: { requiresAuth: true },
  },
  {
    path: '/projects/:projectId/franchise-data',
    name: 'FranchiseDataHub',
    component: FranchiseDataHub,
    meta: { requiresAuth: true },
  },
  {
    // Legacy COI Home → Portfolio hub (canonical post-login home)
    path: '/coi',
    redirect: '/clients',
  },
  {
    path: '/coi/integrations',
    name: 'CoiIntegrations',
    component: CoiIntegrations,
    meta: { requiresAuth: true },
  },
  {
    path: '/growth-contacts',
    name: 'GrowthContacts',
    component: GrowthContacts,
    meta: { requiresAuth: true, requiresPlatformAdmin: true },
  },
  {
    path: '/growth-contacts/:id',
    name: 'GrowthContactProfile',
    component: () => import('@/views/GrowthContactProfile.vue'),
    meta: { requiresAuth: true, requiresPlatformAdmin: true },
  },
  {
    path: '/marketing/scav-roster',
    name: 'ScavRosterContacts',
    component: ScavRosterContacts,
    meta: { requiresAuth: true, requiresPlatformAdmin: true },
  },
  {
    path: '/import-onboarding',
    name: 'ImportOnboarding',
    component: ImportOnboarding,
    meta: { requiresAuth: true },
  },
  {
    path: '/batch-processing',
    name: 'BatchProcessing',
    component: BatchProcessing,
    meta: { requiresAuth: true },
  },
  {
    path: '/batch-processing/:projectId',
    name: 'BatchProcessingProject',
    component: BatchProcessing,
    meta: { requiresAuth: true },
  },
  {
    path: '/coi-import',
    name: 'CoiImport',
    component: CoiImport,
    meta: { requiresAuth: true },
  },
  {
    path: '/rag-analytics-demo',
    name: 'RAGAnalyticsDemo',
    component: RAGAnalyticsDemo,
    meta: { requiresAuth: true },
  },
  {
    path: '/rag-admin-dashboard',
    name: 'RAGAdminDashboard',
    component: RAGAdminDashboard,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/status-changes',
    name: 'StatusChangesReport',
    component: StatusChangesReport,
    meta: { requiresAuth: true },
  },
  {
    path: '/prompt-enhancement',
    name: 'PromptEnhancement',
    component: PromptEnhancement,
    meta: { requiresAuth: true },
  },
  {
    path: '/setup/organization',
    name: 'OrganizationSetupWizard',
    component: OrganizationSetupWizard,
    meta: { requiresAuth: true },
  },
  {
    path: '/setup/compliance-client',
    name: 'ComplianceOnboardingWizard',
    component: ComplianceOnboardingWizard,
    meta: { requiresAuth: true },
  },
  {
    path: '/client-management',
    name: 'ClientManagement',
    component: ClientManagementDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/settings/baa',
    name: 'BAASigningPage',
    component: BAASigningPage,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/settings/developer-agreements',
    name: 'DeveloperAgreementsAdmin',
    component: () => import('@/views/DeveloperAgreementsAdmin.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/sign/developer-agreement/:token',
    name: 'DeveloperAgreementSign',
    component: () => import('@/views/DeveloperAgreementSignPage.vue'),
    meta: { requiresAuth: false },
  },
  // Invoicing routes
  {
    path: '/invoicing',
    name: 'InvoiceList',
    component: InvoiceList,
    meta: { requiresAuth: true },
  },
  {
    path: '/invoicing/new',
    name: 'InvoiceNew',
    component: InvoiceEditor,
    meta: { requiresAuth: true },
  },
  {
    path: '/invoicing/:id/edit',
    name: 'InvoiceEdit',
    component: InvoiceEditor,
    meta: { requiresAuth: true },
  },
  {
    path: '/invoicing/:id',
    name: 'InvoiceDetail',
    component: InvoiceDetail,
    meta: { requiresAuth: true },
  },
  {
    path: '/expenses',
    name: 'BusinessExpenses',
    component: BusinessExpenses,
    meta: { requiresAuth: true },
  },
  {
    path: '/settings/api',
    redirect: '/api-integrations',
  },
  {
    path: '/settings/notifications',
    redirect: '/settings/profile',
  },
  {
    path: '/settings/appearance',
    redirect: '/settings/branding',
  },
  {
    path: '/billing',
    name: 'Billing',
    component: BillingSettings,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/dspy-test',
    name: 'DSPyTestPage',
    component: DSPyTestPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/settings',
    component: Settings,
    meta: { requiresAuth: true },
    redirect: '/settings/profile',
    children: [
      {
        path: 'profile',
        name: 'ProfileSettings',
        component: UserProfile,
      },
      {
        path: 'security',
        name: 'SecuritySettings',
        component: SettingsSecurity,
      },
      {
        path: 'agent-profile',
        name: 'AgentProfileSettings',
        component: AgentProfileSettings,
      },
      {
        path: 'platform',
        name: 'AccountPlatformHub',
        component: AccountPlatformHub,
        meta: { requiresPlatformAdmin: true },
      },
      {
        path: 'marketing',
        name: 'AccountMarketingHub',
        component: AccountMarketingHub,
        meta: { requiresMarketingAccess: true },
      },
      {
        path: 'organization',
        name: 'OrganizationSettings',
        component: OrganizationSettings,
      },
      {
        path: 'users',
        name: 'UserManagement',
        component: UserManagement,
      },
      {
        path: 'email-branding',
        name: 'OrgEmailBranding',
        component: OrgEmailBranding,
      },
      {
        path: 'billing',
        name: 'BillingSettings',
        component: BillingSettings,
      },
      {
        path: 'payments',
        name: 'PaymentSettings',
        component: ConnectOnboarding,
        meta: { requiresAdmin: true },
      },
      {
        path: 'branding',
        name: 'BrandingManager',
        component: () => import('@/components/BrandingManager.vue'),
        meta: { requiresAdmin: true },
      },
    ],
  },
  // Secure Upload Multi-Step Flow
  {
    path: '/secure-upload/:token',
    name: 'SecureUploadLanding',
    component: SecureUploadLanding,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: '/secure-upload/:token/analysis',
    name: 'SecureUploadAnalysis',
    component: SecureUploadAnalysis,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: '/secure-upload/:token/results',
    name: 'SecureUploadResults',
    component: SecureUploadResults,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: '/secure-upload/:token/feedback',
    name: 'SecureUploadFeedback',
    component: SecureUploadFeedback,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: '/secure-upload/:token/complete',
    name: 'SecureUploadComplete',
    component: SecureUploadComplete,
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: '/secure-upload/:token/not-my-client',
    name: 'SecureUploadDecline',
    component: () => import('@/views/SecureUploadDecline.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/rag-carrier-demo',
    name: 'RAGCarrierFocusedDemo',
    component: RAGCarrierFocusedDemo,
    meta: { requiresAuth: true },
  },
  {
    path: '/carrier-analytics',
    name: 'CarrierAnalytics',
    component: CarrierAnalytics,
    meta: { requiresAuth: true },
  },
  {
    path: '/compliance-health',
    name: 'ComplianceHealthDashboard',
    component: ComplianceHealthDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/compliance-health/email-delivery',
    name: 'ComplianceEmailDelivery',
    component: EmailDeliveryHealth,
    meta: { requiresAuth: true },
  },
  {
    path: '/compliance-health/consult',
    name: 'ComplianceConsult',
    component: ComplianceConsult,
    meta: { requiresAuth: true },
  },
  // Wealth Management (Phase 1)
  {
    path: '/wealth',
    name: 'WealthReviewDashboard',
    component: WealthReviewDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/wealth/review/:id',
    name: 'QuarterlyReviewPacket',
    component: QuarterlyReviewPacket,
    meta: { requiresAuth: true },
  },
  {
    path: '/wealth/households/:householdId/ips',
    name: 'IPSEditor',
    component: IPSEditor,
    meta: { requiresAuth: true },
  },
  {
    path: '/wealth/events',
    name: 'EventImpactDashboard',
    component: EventImpactDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/wealth/consult',
    name: 'WealthAdvisorConsult',
    component: WealthAdvisorConsult,
    meta: { requiresAuth: true },
  },
  {
    path: '/wealth/equity-screens',
    name: 'EquityValuationScreens',
    component: () => import('@/views/EquityValuationScreens.vue'),
    meta: { requiresAuth: true },
  },
  // Internal Feedback Dashboard (internal users only)
  {
    path: '/internal/feedback',
    name: 'FeedbackDashboard',
    component: FeedbackDashboard,
    meta: { requiresAuth: true },
  },
  // Build spoke hub (Builder OS / construction tools)
  {
    path: '/build-management',
    name: 'BuildHub',
    component: BuildHub,
    meta: { requiresAuth: true },
  },
  {
    path: '/build-management/:projectId',
    redirect: '/build-management',
  },
  // Knowledge Graph Explorer
  {
    path: '/knowledge-graph',
    name: 'KnowledgeGraphExplorer',
    component: () => import('@/components/knowledge-graph/ContextExplorer.vue'),
    meta: { requiresAuth: true },
  },
  // Construction Dashboard
  {
    path: '/construction-dashboard',
    name: 'ConstructionDashboard',
    component: () => import('@/components/knowledge-graph/ConstructionDashboard.vue'),
    meta: { requiresAuth: true },
  },
  // Master Data Audit Dashboard
  {
    path: '/master-data-audit',
    name: 'MasterDataAudit',
    component: () => import('@/components/construction/MasterDataAuditDashboard.vue'),
    meta: { requiresAuth: true },
  },
  // House Budget Audit View
  {
    path: '/house-budget/:houseNumber',
    name: 'HouseBudgetAudit',
    component: () => import('@/components/construction/HouseBudgetAuditView.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  // Development Budget Overview
  {
    path: '/development-budgets',
    name: 'DevelopmentBudgets',
    component: () => import('@/components/construction/DevelopmentBudgetView.vue'),
    meta: { requiresAuth: true },
  },
  // House Pricing Scenario Builder
  {
    path: '/house-pricing',
    name: 'HousePricing',
    component: () => import('@/components/construction/HousePricingScenarioBuilder.vue'),
    meta: { requiresAuth: true },
  },
  // House Pricing Scenario List
  {
    path: '/house-pricing/scenarios',
    name: 'PricingScenarioList',
    component: () => import('@/components/construction/PricingScenarioList.vue'),
    meta: { requiresAuth: true },
  },
  // House Pricing Scenario View
  {
    path: '/house-pricing/view/:id',
    name: 'PricingScenarioView',
    component: () => import('@/components/construction/PricingScenarioView.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  // House Pricing Scenario Edit
  {
    path: '/house-pricing/edit/:id',
    name: 'PricingScenarioEdit',
    component: () => import('@/components/construction/HousePricingScenarioBuilder.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  // House Pricing Scenario Comparison
  {
    path: '/house-pricing/compare',
    name: 'PricingScenarioComparison',
    component: () => import('@/components/construction/ScenarioComparisonView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/gap-resolution',
    name: 'GapResolutionWorkflow',
    component: () => import('@/components/construction/GapResolutionWorkflow.vue'),
    meta: { requiresAuth: true },
  },
  // Loan Draws & Cash Flow Intelligence
  {
    path: '/loan-draws',
    name: 'LoanDraws',
    component: () => import('@/components/construction/LoanDrawView.vue'),
    meta: { requiresAuth: true },
    props: route => ({
      developmentCode: route.query.dev || '',
      companyCode: route.query.company || '',
    }),
  },
  // Invoice Upload & Auto-Coding
  {
    path: '/invoice-upload',
    name: 'InvoiceUpload',
    component: () => import('@/components/construction/InvoiceUpload.vue'),
    meta: { requiresAuth: true },
    props: route => ({
      companyCode: route.query.company || '',
      developmentCode: route.query.dev || '',
    }),
  },
  // Permit Completion
  {
    path: '/permit-completion',
    name: 'PermitCompletion',
    component: () => import('@/components/construction/PermitCompletion.vue'),
    meta: { requiresAuth: true },
    props: route => ({
      companyCode: route.query.company || '',
      developmentCode: route.query.dev || '',
    }),
  },
  // Builder OS — WIP board
  {
    path: '/construction-wip',
    name: 'ConstructionWip',
    component: () => import('@/components/construction/ConstructionWipBoard.vue'),
    meta: { requiresAuth: true },
  },
  // Builder OS — buyer selections (internal; full portal later)
  {
    path: '/buyer-portal/:houseNumber?',
    name: 'BuyerPortal',
    component: () => import('@/views/BuyerPortalView.vue'),
    meta: { requiresAuth: true },
    props: route => ({
      initialHouseNumber: route.params.houseNumber || route.query.house || '',
    }),
  },
  // Veterinary Clinical Consult — unified into Learning Hub Vet Consult tab
  {
    path: '/vet-consult',
    redirect: (to) => ({
      path: '/learning',
      query: { ...to.query, tab: 'agent' },
    }),
  },
  // LMS Routes
  {
    path: '/learning',
    name: 'LearningCatalog',
    component: LearningCatalog,
    meta: { requiresAuth: true },
  },
  {
    path: '/learning/my-courses',
    name: 'MyLearning',
    component: MyLearning,
    meta: { requiresAuth: true },
  },
  {
    path: '/learning/my-library',
    name: 'MyLibrary',
    component: MyLibrary,
    meta: { requiresAuth: true },
  },
  {
    path: '/learning/patients',
    name: 'LearningPatients',
    component: () => import('@/views/PatientsListView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/learning/patients/:subjectId',
    name: 'LearningPatientChart',
    component: PatientChartView,
    props: (route) => ({
      subjectId: route.params.subjectId,
    }),
    meta: { requiresAuth: true },
  },
  {
    path: '/learning/paths',
    name: 'LearningPaths',
    component: LearningPaths,
    meta: { requiresAuth: true },
  },
  {
    path: '/learning/search',
    name: 'UnifiedLearningSearch',
    component: () => import('@/components/lms/UnifiedLearningSearch.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/learning/courses/:id',
    name: 'CourseDetail',
    component: CourseDetail,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/learning/courses/:courseId/video/:videoId',
    name: 'CourseVideoPlayer',
    component: CourseVideoPlayer,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/learning/courses/:id/certificate/view',
    name: 'CourseCertificate',
    component: CourseCertificate,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/learning/live-events/:eventId',
    name: 'LiveEventRoom',
    component: () => import('@/views/LiveEventRoom.vue'),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/learning/courses/:courseId/quiz',
    name: 'CourseQuiz',
    component: () => import('@/views/CourseQuiz.vue'),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/learning/author-portal',
    name: 'AuthorPortal',
    component: () => import('@/views/AuthorPortalView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/learning/admin',
    name: 'LMSAdmin',
    component: LMSAdmin,
    meta: { requiresAuth: true, requiresLmsAdmin: true },
  },
  {
    path: '/learning/engagement',
    name: 'LMSEngagement',
    component: () => import('@/views/LMSEngagementPage.vue'),
    meta: { requiresAuth: true, requiresLmsAdmin: true },
  },
  {
    path: '/agent-activity',
    name: 'AgentActivity',
    component: () => import('@/views/AgentActivityDashboard.vue'),
    meta: { requiresAuth: true, requiresPlatformAdmin: true },
  },
  {
    path: '/ingestion/dry-run',
    name: 'FinancialIngestionDryRun',
    component: () => import('@/views/FinancialIngestionDryRun.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/cost-allocation',
    name: 'CostAllocation',
    component: () => import('@/views/CostAllocationDashboard.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Paths a SPEAKER (CE faculty) is allowed to access — see routeAccess.js
// COMPLIANCE_OPS workspace prefixes — see routeAccess.js

router.beforeEach((to, from, next) => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

  // VMAE association hosts: branded portal instead of generic ADI marketing homepage
  if (isVmaeAssociationHost(hostname)) {
    if (to.path === '/' || to.name === 'Home') {
      if (auth.isAuthenticated()) {
        const orgSlug = auth.getUser()?.organization?.slug;
        next(learningHomeLocation(orgSlug));
        return;
      }
      next('/portal');
      return;
    }
  }

  // If user is authenticated and trying to access home page, redirect based on org/role
  if (to.path === '/' && auth.isAuthenticated()) {
    const user = auth.getUser();
    const userRole = auth.getUserRole();
    const orgSlug = user?.organization?.slug;

    if (
      isLearningPortalOrg(orgSlug)
      || userRole === 'STUDENT'
      || userRole === 'LEARNER'
      || userRole === 'SPEAKER'
    ) {
      next(learningHomeLocation(orgSlug));
    } else if (userRole === 'BUILDER') {
      // Builder role is scoped to Build Management only
      next('/construction-dashboard');
    } else if (
      userRole === 'COMPLIANCE_OPS'
      || userRole === 'PLATFORM_ADMIN'
      || userRole === 'PLATFORM_ENGINEER'
      || userRole === 'ORG_ADMIN'
      || userRole === 'COMPLIANCE_ADMIN'
      || userRole === 'ANALYST'
      || userRole === 'ADMIN'
      || userRole === 'VIEWER'
    ) {
      next('/clients');
    } else {
      next('/clients');
    }
    return;
  }

  // SPEAKER role is scoped strictly to LMS + Vet Consult + their own
  // profile. Bounce them off anything else (Decision Center, Clients,
  // Projects, A/B Testing, etc.) so the deep-links from emails or
  // browser history can't drop them on pages they have no business on.
  if (auth.isAuthenticated() && auth.getUserRole() === 'SPEAKER' && !isSpeakerAllowedPath(to.path)) {
    next(learningHomeLocation(auth.getUser()?.organization?.slug));
    return;
  }

  if (auth.isAuthenticated() && auth.getUserRole() === 'COMPLIANCE_OPS' && !isComplianceOpsAllowedPath(to.path)) {
    storeAccessDeniedNotice(to.fullPath || to.path)
    next('/clients')
    return
  }
  
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    if (!auth.isAuthenticated()) {
      next({ path: '/login', query: { redirect: to.fullPath } });
      return;
    }
    if (!auth.isAdmin() && !auth.isComplianceOps()) {
      next('/compliance-health');
      return;
    }
  }

  if (to.matched.some(record => record.meta.requiresPlatformAdmin)) {
    if (!auth.isAuthenticated()) {
      next({ path: '/login', query: { redirect: to.fullPath } });
      return;
    }
    if (!auth.canViewGrowthEngine()) {
      next('/compliance-health');
      return;
    }
  }

  if (to.matched.some(record => record.meta.requiresMarketingAccess)) {
    if (!auth.isAuthenticated()) {
      next({ path: '/login', query: { redirect: to.fullPath } });
      return;
    }
    if (!auth.canAccessMarketing()) {
      next('/clients');
      return;
    }
  }

  if (to.matched.some(record => record.meta.requiresLmsAdmin)) {
    if (!auth.isAuthenticated()) {
      next({ path: '/login', query: { redirect: to.fullPath } });
      return;
    }
    if (!auth.isLmsAdmin()) {
      next(learningHomeLocation(auth.getUser()?.organization?.slug));
      return;
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.isAuthenticated()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router 